import { httpClient, parseQueryParam } from '@/app/shared/services';

export const CLIENT_TYPE_STORE_MODULE_NAME = 'client-types';

export const clientTypesStoreModule = {
  namespaced: true,
  state: {
    data: [],
    meta: {},
  },
  getters: {
    autocompleteClientTypes: (state) => state.data.map((p) => ({ value: p.id, label: p.title })),
  },
  mutations: {
    SET_DATA(state, payload) {
      state.data = payload;
    },
    SET_META(state, payload) {
      state.meta = payload;
    },
  },
  actions: {
    fetchClientTypes({ commit }, queryParams) {
      return new Promise((res, rej) => {
        const params = parseQueryParam(queryParams);
        httpClient
          .get(`/client/types${params}`)
          .then((response) => {
            const { data, meta } = response.data;
            commit('SET_DATA', data);
            commit('SET_META', meta);
            res(response);
          })
          .catch((error) => rej(error));
      });
    },
    updateClientTypes(_, { id, payload }) {
      return new Promise((res, rej) => {
        httpClient
          .put(`/client/types/${id}`, payload)
          .then((response) => res(response))
          .catch((error) => rej(error));
      });
    },
    createClientTypes({ commit, state }, payload) {
      return new Promise((res, rej) => {
        httpClient
          .post('/client/types', payload)
          .then((response) => {
            const { data } = response.data;
            const newData = state.data;
            newData.push(data);
            commit('SET_DATA', newData);
            res(response);
          })
          .catch((error) => rej(error));
      });
    },
    deleteClientTypes({ commit, state }, { id }) {
      return new Promise((res, rej) => {
        httpClient
          .delete(`/client/types/${id}`)
          .then((response) => {
            commit(
              'SET_DATA',
              state.data.filter((item) => item.id !== id)
            );
            res(response);
          })
          .catch((error) => rej(error));
      });
    },
  },
};
